/**
 * Anniversary Hero Slider — anniversary-hero.js
 * File: assets/anniversary-hero.js
 */

(function () {
  'use strict';

  function initHeroSlider(section) {
    var slides = section.querySelectorAll('.ann-hero__slide');
    var tabs = section.querySelectorAll('.ann-hero__tab');
    var prevBtn = section.querySelector('.ann-hero__arrow--prev');
    var nextBtn = section.querySelector('.ann-hero__arrow--next');
    
    if (slides.length === 0) return;

    var currentIndex = 0;
    var slideCount = slides.length;

    function goTo(index) {
      if (index < 0) index = slideCount - 1;
      if (index >= slideCount) index = 0;

      currentIndex = index;

      // Update Slides
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });

      // Update Tabs
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === currentIndex);
      });

      // Update Arrows (optional: disable if not infinite, but hero usually is)
      if (prevBtn) prevBtn.disabled = (currentIndex === 0 && slideCount <= 1);
      if (nextBtn) nextBtn.disabled = (currentIndex === slideCount - 1 && slideCount <= 1);
    }

    // Arrow Listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    // Tab Listeners
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.tabIndex, 10);
        if (!isNaN(idx)) goTo(idx);
      });
    });

    // Initial state
    goTo(0);
  }

  function bootHero() {
    document.querySelectorAll('.anniversary-hero').forEach(function (section) {
      if (section.dataset.heroInit) return;
      section.dataset.heroInit = '1';
      initHeroSlider(section);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.anniversary-hero');
    if (section) initHeroSlider(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHero);
  } else {
    bootHero();
  }

})();
